import '@smastrom/react-rating/style.css';
import 'leaflet/dist/leaflet.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-photo-view/dist/react-photo-view.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { Toaster as SonarToaster } from 'sonner';
import { WHATSAPP_ICON } from './helpers';
import './index.css';
import { AuthProvider } from './modules/Auth/Core';
import MainRoutes from './navigations';
import { store } from './redux/store';
import reportWebVitals from './reportWebVitals';
import { Button } from './shadcn/components/ui';
import { Toaster } from './shadcn/components/ui/toaster';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});


root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider >
        <QueryClientProvider client={queryClient}>
          <MainRoutes />
          <div className='fixed left-10 bottom-12'>
            <a href={process.env.REACT_APP_WHATSAPP_LINK} target={'_blank'}  className='flex flex-col items-center space-x-1 text-green-700 hover:text-primary'>
              <div className='text-base font-semibold order-2'>Talk To Us</div>
              <Button className='bg-green-700 px-3 order-1 h-[55px] text-white rounded-full'>
                <img src={WHATSAPP_ICON} style={{width:"32px",height:"32px"}} />
              </Button>
            </a>

          </div>
          <SonarToaster duration={2000} position='top-center' richColors theme='light' />
          <Toaster />
        </QueryClientProvider>
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
